<script setup lang="ts">
import { IconChevronDown } from "@tabler/icons-vue";
import {
	SelectIcon,
	SelectTrigger,
	type SelectTriggerProps,
	useForwardProps,
} from "reka-ui";
import { twMerge } from "tailwind-merge";
import { computed, type HTMLAttributes } from "vue";

const props = defineProps<
	SelectTriggerProps & { class?: HTMLAttributes["class"] }
>();

const delegatedProps = computed(() => {
	const { class: _, ...delegated } = props;

	return delegated;
});

const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<SelectTrigger
		v-bind="forwardedProps"
		:class="
			twMerge(
				'flex h-10 w-full items-center justify-between rounded-md border border-input bg-background px-3 py-2 text-sm ring-offset-background placeholder:text-muted-foreground focus:outline-hidden focus:ring-2 focus:ring-ring focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1',
				props.class,
			)
		"
	>
		<slot />
		<SelectIcon as-child>
			<IconChevronDown class="w-4 h-4 shrink-0 opacity-50" />
		</SelectIcon>
	</SelectTrigger>
</template>
